import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { CoinProductsApi } from '../parsers';
import { fetchCoinProducts } from '../utils/api';
import {
  SET_COUNTRY_CODE_AND_CURRENCY,
  UPDATE_COUNTRY_CODE_AND_CURRENCY,
} from '../redux/env';
import {
  COIN_PRODUCTS_REQUESTED,
  coinProductsRequested,
  coinProductsFailed,
  coinProductsSucceeded,
} from '../redux/coinProducts';

import type { ActionObs, Store, Obs } from '../types';

export function coinProductsEpic(action$: ActionObs, store: Store): Obs {
  return action$
    .ofType(COIN_PRODUCTS_REQUESTED)
    .switchMap(({ payload: { currency, preferred_currency } }) =>
      fetchCoinProducts({ currency, preferred_currency })
        .map(resp => CoinProductsApi.parse(resp))
        .map(({ coinProducts }) => coinProductsSucceeded(coinProducts))
        .catch(err => Observable.of(coinProductsFailed(err.message))),
    );
}

export function coinProductsAccountAvailableEpic(
  action$: ActionObs,
  store: Store,
): Obs {
  return action$
    .ofType(SET_COUNTRY_CODE_AND_CURRENCY, UPDATE_COUNTRY_CODE_AND_CURRENCY)
    .map(() => {
      const { currency, preferredCurrency } = store.getState().env;
      return coinProductsRequested(currency, preferredCurrency);
    });
}

export default combineEpics(coinProductsEpic, coinProductsAccountAvailableEpic);
